



























import { computed, defineComponent, reactive } from '@vue/composition-api';
import { useQuery } from '@vue/apollo-composable';

import hubDeliveryTime from '@/gql/managementReport/04-DeliveryTime/hubDeliveryTime.gql';

import CommonHubSelector from '@/components/CommonHubSelector.vue';
import ScrollableHorizontalBarChart from '@/components/Vivat/Chart/ScrollableHorizontalBarChart.vue';

import {
  NOW_START_MONTH,
  NOW_END_MONTH,
} from '@/utils';
import {
  deliveryTimeColor,
} from '@/useDelivery';

interface HubDeliveryTime { day0: number; day1: number; day2: number; day4: number; day7: number; hub: string; hubCode: string }
const DeliveryTimeByHub = defineComponent({
  components: {
    CommonHubSelector,
    ScrollableHorizontalBarChart,
  },
  props: {
    height: {},
  },
  setup(props) {
    const filter = reactive({
      hub: null,
      monthRange: {
        from: NOW_START_MONTH,
        to: NOW_END_MONTH,
      },
    });

    const { result, loading } = useQuery(hubDeliveryTime, computed(() => ({
      timeframe: filter.monthRange,
    })));

    const chartData = computed(() => {
      const labels: string[] = [];
      const day0: number[] = [];
      const day1: number[] = [];
      const day2: number[] = [];
      const day4: number[] = [];
      const day7: number[] = [];
      (result?.value?.hubsDeliveryTime || []).forEach((item: HubDeliveryTime) => {
        labels.push(item.hub);
        day0.push(item.day0);
        day1.push(item.day1);
        day2.push(item.day2);
        day4.push(item.day4);
        day7.push(item.day7);
      });

      return {
        labels,
        datasets: [
          {
            label: 'วันเดียว',
            data: day0,
            backgroundColor: deliveryTimeColor.day1,
            stack: 'STACK',
          },
          {
            label: 'วันถัดไป',
            data: day1,
            backgroundColor: deliveryTimeColor.day2,
            stack: 'STACK',
          },
          {
            label: 'ภายใน 3 วัน',
            data: day2,
            backgroundColor: deliveryTimeColor.day3,
            stack: 'STACK',
          },
          {
            label: 'ภายใน 4-7 วัน',
            data: day4,
            backgroundColor: deliveryTimeColor.day4,
            stack: 'STACK',
          },
          {
            label: 'มากกว่า 7 วัน',
            data: day7,
            backgroundColor: deliveryTimeColor.day7,
            stack: 'STACK',
          },
        ],
      };
    });

    return {
      filter,
      chartData,
    };
  },
});

export default DeliveryTimeByHub;
